// 合并数组对象
const getList = (obj: any) => {
    // 初始化图片列表，把图片和link放在数组中
    let _initList: object[] = [];
    Object.keys(obj).forEach((v: any) => {
        if (v.indexOf('picture') > -1) {
            _initList.push({picture: obj[v], key: v.charAt(v.length - 1)})
        }
        if (v.indexOf('link') > -1) {
            _initList.push({link: obj[v], key: v.charAt(v.length - 1)})
        }
    });
    // 获取数组项数
    const keyArr: number[] = [];
    _initList.forEach((v: any, k: number) => {
        console.log();
        
        if (k < _initList.length / 2) {
            keyArr.push(k + 1);
        }
    })
    // 得到最终的数组的对象{link + picture}
    let _lastList: object[] = [];
    keyArr.forEach((v: any, k: number) => {
        _initList.forEach((vv: any) => {
            if (Number(vv.key) === v) {
                _lastList[k] = {..._lastList[k], ...vv};
            }
        })
    });
    const _result = _lastList.filter((v: any) => v.picture);
    return _result;
}

// 格式化modules
const formatModules = (modules: object[]) => {
    const _m: any = modules.map((v: any) => {
        // 轮播图
        if (v.siteModuleId === 2) {
            const pictureLinkList = getList(v.siteUserCarouselFigure);
            return {
                ...v,
                siteUserCarouselFigure: {
                    ...v.siteUserCarouselFigure,
                    pictureLinkList,
                }
            }
        }
        // 中心二分图
        if (v.siteModuleId === 5) {
            const pictureLinkList = getList(v.siteUserCenterDichotomize);
            return {
                ...v,
                siteUserCenterDichotomize: {
                    ...v.siteUserCenterDichotomize,
                    pictureLinkList,
                }
            }
        }
        // 中心三分图
        if (v.siteModuleId === 6) {
            const pictureLinkList = getList(v.siteUserCenterThirds);
            return {
                ...v,
                siteUserCenterThirds: {
                    ...v.siteUserCenterThirds,
                    pictureLinkList,
                }
            }
        }
        return {
            ...v,
        }
    });
    return _m;
};

// 正序排序
const sortFn = (list: object[]) => {
    return list.sort((a: any, b: any) => Number(a.sort) - Number(b.sort));
};

// 按商品id排序
const goodsIdsOrderFn = (goodsIds: string[], goodsList: any[]) => {
    if (!goodsIds) {
      return [];
    }
    const _l: any[] = [];
    goodsIds.forEach((v: any) => {
        goodsList.forEach((vv: any) => {
            Number(vv.id) === Number(v) && _l.push(vv);
        });
    });
    return _l;
};

// 根据type获取不同的自定义商品及默认商品列表 module
const getmoduleZDY = (type: number, goodsModuleArr: any[], goodsObj: any) => {
    let moduleZDY: any = {};
    if (type === 999) {
      // 默认商品
      moduleZDY = {
        ...goodsModuleArr[0],
        siteUserActivityList: {
          ...goodsModuleArr[0].siteUserActivityList,
          goodsObj,
        },
      };
    } else if (type === 10) {
      // 3D看车数据
      moduleZDY = {
        ...goodsModuleArr[0],
        siteUser3dCar: {
          ...goodsModuleArr[0].siteUser3dCar,
          goodsObj: {
            ...goodsObj,
            list: goodsIdsOrderFn(
              goodsModuleArr[0]?.siteUser3dCar?.goodsIds?.split(","),
              goodsObj.list
            ),
          },
        },
      };
    } else {
      // 其他商品
      goodsModuleArr.forEach((v: any) => {
        if (v.siteUserCustomGoods.styleType === type) {
          moduleZDY = {
            ...v,
            siteUserCustomGoods: {
              ...v.siteUserCustomGoods,
              goodsObj: {
                ...goodsObj,
                list: goodsIdsOrderFn(
                  v.siteUserCustomGoods.goodsIds.split(","),
                  goodsObj.list
                ),
              },
            },
          };
        }
      });
    }
    return moduleZDY;
};

// 解析后台html标签
const tohtml = (str: any) => {
    let arrEntities: any = {
        'lt': '<',
        'gt': '>',
        'nbsp': ' ',
       'amp': '&',
        'quot': '"'
   };
   return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all: any, t: any) {
       return arrEntities[t]
   })
};

export default { formatModules, sortFn, getmoduleZDY };